import React, {useEffect, useState } from 'react';
import { DataGridPro, LicenseInfo } from '@mui/x-data-grid-pro';
import Box from '@mui/material/Box';
import { IconButton } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import LinearProgress from '@mui/material/LinearProgress';


LicenseInfo.setLicenseKey('17ca2e8476fa658618680f9f135dbc81T1JERVI6MzU2MTYsRVhQSVJZPTE4NzMzODQyMDIwMDAsS0VZVkVSU0lPTj0x',);

const GreenCheck = () => {
    return(
        <CheckIcon style={{ color:'#19f745' }} />
    )
}
const RedCross = () => {
    return(
        <CloseIcon style={{ color:'#f72019'}} />
    )
}

// In milliseconds

export default function LinkingDataGrid(props) {
    const { rows, columns, selectionModel, onSelectionModelChange, loading, disableMultipleSelection=false } = props
    const [isLoading, setIsLoading] = useState(false)
    const [startTime, setStartTime] = useState(new Date())
    const [endTime, setEndTime] = useState(new Date())

    useEffect(()=>{
        if (loading === true){
            setIsLoading(true)
            setStartTime(new Date())
        }
        if (loading === false){
            setIsLoading(false)
        }
    },[loading])

    return (
        <React.Fragment>
        <DataGridPro 
            disableMultipleRowSelection={disableMultipleSelection}
            loading={isLoading}
            sx={{
                bgcolor: "rgba(0,0,0,0.9)",
                boxShadow: 2,
                border: 0,
                '& .MuiSvgIcon-root': {
                    color: "rgba(178, 186, 194, 0.4)"
                },
                // Transition reduces split second switch to non-selected style on mouseover change
                '& .MuiDataGrid-row':{
                    transition: '0.1s'
                },
                '& .MuiDataGrid-footerContainer': {
                    justifyContent:'flex-start',
                    color:'grey',
                    borderTop: "1px solid rgba(224, 224, 224, 0.8)"
                },
                '& .MuiDataGrid-overlay': {
                    backgroundColor: "rgba(255, 255, 255, 0.01)"
                },
                '& .MuiDataGrid-row.Mui-selected': {
                    backgroundColor: "rgba(36, 108, 164, 0.35)",
                },
                '& .MuiDataGrid-row.Mui-selected:hover': {
                    backgroundColor: "rgba(36, 108, 164, 0.35)",
                },
                '& .MuiDataGrid-columnHeaderTitle': {
                    color: "rgb(255, 255, 255)",
                    fontWeight: "bold",
                },
                '& .MuiDataGrid-columnHeadersInner': {
                    backgroundColor: "rgba(0, 0,0 , 0.1)",
                },
                '& .MuiDataGrid-pinnedColumns': {
                    backgroundColor: "#1c2025",
                    backgroundImage: 'none',
                    
                    boxShadow: '0px 3px 1px -2px rgb(0 0 0 / 50%), 0px 2px 2px 0px rgb(0 0 0 / 40%), 0px 1px 5px 0px rgb(36 108 164 / 90%)',
                },
                '& .MuiDataGrid-pinnedColumnHeaders': {
                    backgroundColor: "rgb(40,44,52)",
                    backgroundImage: 'none',
                    boxShadow: 'none',
                    borderColor: "rgba(77, 78, 82, 0.7)",
                },
                '& .MuiDataGrid-cell': {
                color: "rgb(255, 255, 255)",
                borderColor: "rgba(77, 78, 82, 0.7)",
                },
                '& .MuiDataGrid-virtualScroller': {
                    flex: "1 1 0px",
                    overflow: "auto"
                },
                '& .MuiLinearProgress-root':{
                    backgroundColor:'green'
                },
                
            }}
            rows={rows}
            columns={columns}
            pageSize={4}
            components={{ 
                LoadingOverlay: LinearProgress, 
                BooleanCellTrueIcon: GreenCheck,
                BooleanCellFalseIcon: RedCross
            }}
            rowSelectionModel={selectionModel}
            onRowSelectionModelChange={(newRowSelectionModel) => {
                onSelectionModelChange(newRowSelectionModel);
            }}
            rowHeight={100}  />
        </React.Fragment>
    )
 }
